var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"el-icon-back back-arrow",attrs:{"title":'返回'}})
}
var staticRenderFns = []

export { render, staticRenderFns }